<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Mis Transacciones</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="3" class="mt-4 mb-2 d-none d-lg-block">
                <b-button variant="default" pill block size="sm" to="/request">
                    <i class="material-icons mdi mdi-send-circle"></i>&nbsp;
                    <span>Nueva Transacción</span>
                </b-button>
            </b-col>
            <b-col cols="12" lg="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay transacciones que coincidan con la búsqueda"
                    empty-text="No hay transacciones para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(show_details)="row">
                        <b-button variant="default" size="sm" v-b-modal.qr @click="getQR(row.item.id)" class="mr-2" v-if="row.item.status === '103'">
                            <i class="material-icons">qr_code_2</i>
                        </b-button>
                        <b-button variant="info" size="sm" @click="row.toggleDetails" class="mr-2">
                            <i :class="row.detailsShowing ? 'material-icons rotate180' : 'material-icons'">expand_circle_down</i>
                        </b-button>
                    </template>

                    <template #cell(status_text)="row">
                        <template v-if="row.item.status === 109">
                            <span class="bg-success text-light rounded py-1 px-2">{{ row.item.status_text }}</span>
                        </template>
                        <template v-else-if="row.item.status === 110 || row.item.status === 111 || row.item.status === 112 || row.item.status === 113">
                            <span class="bg-danger text-light rounded py-1 px-2">{{ row.item.status_text }}</span>
                        </template>
                        <template v-else>
                            <span>{{ row.item.status_text }}</span>
                        </template>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>

                    <template #row-details="row">
                        <b-card class="rounded-0">
                            <b-row  align-h="center" class="mx-0" v-if="row.item.destiny_pay === 'Bank'">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Banco:</b> {{ row.item.bank_info.name }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Cuenta {{ row.item.receiver.tc }}:</b> {{ row.item.receiver.nc }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0" v-else>
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Oficina:</b> {{ row.item.office_info.name }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Pagador:</b> {{ row.item.office_info.payer }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Documento:</b> {{ row.item.receiver.td }} {{ row.item.receiver.nd }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Email:</b> {{ row.item.receiver.email }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Valor Pagado:</b> {{ Number(row.item.amount_send).toLocaleString("en-US") + ' ' + row.item.currency_send }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Comisión:</b> {{ Number(row.item.fee).toLocaleString("en-US") + ' ' + row.item.currency_send }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Valor Enviado:</b> {{ Number(row.item.amount_send - row.item.fee).toLocaleString("en-US") + ' ' + row.item.currency_send }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Valor Recibido:</b> {{ Number(row.item.amount_receiver).toLocaleString("en-US") + ' ' + row.item.currency_receiver }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Fecha Creación:</b> {{ new Date((''+row.item.date).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Fecha Actualización:</b> {{ new Date((''+row.item.update).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center">
                                <b-col cols="12" class="text-center mt-3">
                                    <b-button variant="success" :to="'/history/details/'+row.item.id" class="mr-2">
                                        <i class="material-icons mdi mdi-eye"></i> Mas información
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                </b-table>

                <!-- Modal QR -->
                <b-modal
                    id="qr"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center"
                    :title="'ID: ' + qrTitle"
                    tabindex="-1"
                    role="dialog"
                    aria-hidden="true">
                    <b-row no-gutters class="justify-content-center">
                        <b-col cols="12" class="p-4">
                            <vue-qrcode :value="qrImg" :scale="8" :margin="0" :version="3" />
                        </b-col>
                    </b-row>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";
import VueQrcode from "vue-qrcode";

export default {
    name: "History",
    components: {VueQrcode},
    data: () => ({
        qrTitle: 0,
        qrImg: '',
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: true },
            { key: 'rname', label: 'Nombre', sortable: true },
            { key: 'country_receiver_text', label: 'País', sortable: true },
            { key: 'status_text', label: 'Estado', sortable: true },
            { key: 'show_details', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'historypage');
        this.totalRows = this.items.length;
        this.getIni();
    },
    methods: {
        getIni() {
            axios.get('/api/customer/payments').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        getQR(v) {
            this.qrTitle = v;
            const md5 = require('md5');
            this.qrImg = md5((v).toString());
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    }
}
</script>

<style scoped>

</style>
